import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import type { FilterField } from '../../../api/models/filters.model';

interface StringFilterFieldProps {
	field: FilterField;
	value: string[];
	onChange: (val: any) => void;
}

const StringFilterField = ({ field, value, onChange }: StringFilterFieldProps) => {
	const [searchValue, setSearchValue] = React.useState('');

	const getOptions = (): string[] => {
		return field.values?.filter((val): val is string => typeof val === 'string') || [];
	};

	const handleChange = (_event: any, newValue: any[]) => {
		if (Array.isArray(newValue)) {
			onChange(newValue.filter((v) => typeof v === 'string'));
		} else {
			onChange([]);
		}
	};

	return (
		<div>
			{field.values && field.values.length === 0 ? (
				<div>No available values</div>
			) : (
				<Autocomplete
					multiple
					data-testid={`string-filter-field-${field.name}`}
					options={getOptions()}
					value={Array.isArray(value) ? value : []}
					onChange={handleChange}
					inputValue={searchValue}
					onInputChange={(_, newValue) => {
						setSearchValue(newValue);
					}}
					filterSelectedOptions
					freeSolo={false}
					renderInput={(params) => <TextField {...params} label="Search" placeholder="Search" />}
				/>
			)}
		</div>
	);
};

export default StringFilterField;
